<h3>
  {{
  editForm.value.isNewRow ? 'Create Controller Software' : 'Edit ' + editForm.value.controllerSoftwareVersion + '
  Controller Software'
  }}
</h3>
<br />
<form [formGroup]="editForm">
  <div style="display: flex; gap: 10px;">
    <!-- Family Code -->
    <div (click)="onFamilyCodeFormFieldClick()" style="flex: 2">
      <mat-form-field appearance="outline" [ngClass]="{'editable-outline': true}" style="width: 100%">
        <mat-label>Family Code</mat-label>
        <button mat-icon-button matSuffix tabindex="-1" style="pointer-events: none;">
          <mat-icon class="icon-color-fix-orange">search</mat-icon>
        </button>
        <input type="text" matInput [ngModelOptions]="{standalone: true}" [(ngModel)]="selectedFamilyCodeId"
          [matAutocomplete]="auto" (input)="onFamilyCodesFilter($event)" placeholder="Search" />
          <mat-autocomplete #auto="matAutocomplete" [displayWith]="getFamilyCodeText.bind(this)"
            (optionSelected)="onFamilyCodeSelected($event)">
            @for (fc of filteredFamilyCodes; track fc) {
              <mat-option [value]="fc.familyCodeId">
                {{ getFamilyCodeText(fc.familyCodeId) }}
              </mat-option>
            }
          </mat-autocomplete>
        </mat-form-field>
      </div>
      <!-- Controller Software Version -->
      <div style="flex: 1">
        <mat-form-field appearance="outline" [ngClass]="{'editable-outline': editForm.value.isNewRow}"
          style="width: 100%">
          <mat-label>Controller Software</mat-label>
          @if (!editForm.value.isNewRow) {
            <input matInput [value]="editForm.value.controllerSoftwareVersion" readonly />
          } @else {
            <input matInput type="text" formControlName="controllerSoftwareVersion" maxlength="10"
              matTooltip="Max 10 characters" />
            }
          </mat-form-field>
        </div>
        <!-- Software Version -->
        <div style="flex: 1">
          <mat-form-field appearance="outline" [ngClass]="{'editable-outline': editForm.value.isNewRow}"
            style="width: 100%">
            <mat-label>Version</mat-label>
            @if (!editForm.value.isNewRow) {
              <input matInput [value]="editForm.value.softwareVersion" readonly />
            } @else {
              <input matInput type="text" formControlName="softwareVersion" maxlength="50"
                matTooltip="Max 50 characters" />
              }
            </mat-form-field>
          </div>
          <!-- Release Name -->
          <div style="flex: 1">
            <mat-form-field appearance="outline" [ngClass]="{'editable-outline': editForm.value.isNewRow}"
              style="width: 100%">
              <mat-label>Release Name</mat-label>
              @if (!editForm.value.isNewRow) {
                <input matInput [value]="editForm.value.releaseName" readonly />
              } @else {
                <input matInput type="text" formControlName="releaseName" maxlength="50"
                  matTooltip="Max 50 characters" />
                }
              </mat-form-field>
            </div>
          </div>
          <div style="display: flex; gap: 10px;">
            <!-- Software File -->
            <div (click)="fileInput.click()" style="flex: 1">
              <mat-form-field appearance="outline" [ngClass]="{'editable-outline': true}" style="width: 100%">
                <mat-label>Software File</mat-label>
                <input matInput [value]="editForm.value.softwareFileName" readonly
                  [placeholder]="!editForm.value.softwareFileName ? 'No file selected' : ''" />
                  <button mat-icon-button matSuffix aria-label="Browse file">
                    <mat-icon matSuffix class="icon-color-fix-orange">sync</mat-icon>
                  </button>
                </mat-form-field>
                <input #fileInput type="file" style="display: none" (change)="onFileChange($event)" />
              </div>
              <!-- Product Usage -->
              <div (click)="onProductUsageFormFieldClick()" style="flex: 1">
                <mat-form-field appearance="outline" [ngClass]="{'editable-outline': true}" style="width: 100%">
                  <mat-label>Product Usage</mat-label>
                  <button mat-icon-button matSuffix tabindex="-1" style="pointer-events: none;">
                    <mat-icon class="icon-color-fix-orange">search</mat-icon>
                  </button>
                  <input type="text" matInput [ngModelOptions]="{standalone: true}" [(ngModel)]="selectedProductUsageId"
                    [matAutocomplete]="autoPU" (input)="onProductUsageFilter($event)" placeholder="Search" />
                    <mat-autocomplete #autoPU="matAutocomplete" [displayWith]="getProductUsageText.bind(this)"
                      (optionSelected)="onProductUsageSelected($event)">
                      @for (pu of filteredProductUsages; track pu) {
                        <mat-option [value]="pu.productUsageID">
                          {{ getProductUsageText(pu.productUsageID) }}
                        </mat-option>
                      }
                    </mat-autocomplete>
                  </mat-form-field>
                </div>
                <!-- TDC Agent Version -->
                <div style="flex: 1">
                  <mat-form-field appearance="outline" [ngClass]="{'editable-outline': editForm.value.isNewRow}"
                    [class.disabled]="!editForm.value.isNewRow"
                    style="width: 100%">
                    <mat-label>Agent Version</mat-label>
                    @if (!editForm.value.isNewRow) {
                      <input matInput [value]="editForm.value.tdcAgentVersion" readonly />
                    } @else {
                      <input matInput type="text" formControlName="tdcAgentVersion" maxlength="10"
                        matTooltip="Max 10 characters" />
                      }
                    </mat-form-field>
                  </div>
                </div>
                <div style="display: flex; gap: 10px;">
                  <!-- Modified by -->
                  @if (!editForm.value.isNewRow) {
                    <div style="flex: 1"></div>
                    <div style="flex: 1">
                      <mat-form-field appearance="outline" style="width: 100%" [class.disabled]="true">
                        <mat-label>Modified by</mat-label>
                        <input matInput [value]="editForm.value.modifUser" readonly />
                      </mat-form-field>
                    </div>
                  }

                </div>

                @if (!editForm.value.isNewRow) {
                  <h3>Model file</h3>
                  <div style="display: flex; gap: 20px; flex-wrap: wrap;">
                    <!-- Existing model file -->
                    @if (editForm.value.modelFileId && editForm.value.modelFileId !== 0) {
                      <div (click)="openExistingModelFile()" style="flex: 0 0 150px; max-width: 150px; cursor: pointer;">
                        <mat-form-field appearance="outline"
                          [ngClass]="{'editable-outline': true}"
                          [class.disabled]="true"
                          style="width: 100%">
                          <mat-label>Model File</mat-label>
                          <input matInput
                            [value]="editForm.value.modelFileReleaseName"
                            readonly />
                            <button mat-icon-button matSuffix aria-label="Open">
                              <mat-icon matSuffix class="icon-color-fix-orange">edit</mat-icon>
                            </button>
                          </mat-form-field>
                        </div>
                      }
                      <!-- 'Add model file' button -->
                      @if (!editForm.value.modelFileId || editForm.value.modelFileId === 0) {
                        <div
                          style="flex: 0 0 150px; max-width: 150px; cursor: pointer;"
                          (click)="openModelFiles(null, true)">
                          <mat-form-field appearance="outline" [ngClass]="{'editable-outline': true}" [class.disabled]="true" style="width: 100%">
                            <mat-icon matPrefix class="icon-color-fix-orange">add</mat-icon>
                            <input matInput [value]="'New model file'" readonly />
                          </mat-form-field>
                        </div>
                      }
                    </div>
                    <input #modelFileInput
                      type="file"
                      accept=".json"
                      style="display: none"
                      (change)="onModelFileChange($event)" />
                    }

                    @if (!editForm.value.isNewRow) {
                      <h3>Release notes</h3>
                      <div style="display: flex; gap: 20px; flex-wrap: wrap;">
                        <!-- Existing release notes -->
                        @for (note of editForm.value.availableReleaseNotes || []; track note) {
                          <div (click)="openReleaseNotes(note)" style="flex: 0 0 150px; max-width: 150px; cursor: pointer;">
                            <mat-form-field appearance="outline" [ngClass]="{'editable-outline': true}" [class.disabled]="true" style="width: 100%">
                              <mat-label>Release notes</mat-label>
                              <input matInput [value]="getReleaseNoteLabelText(note.language)" readonly />
                              <button mat-icon-button matSuffix aria-label="Open">
                                <mat-icon matSuffix class="icon-color-fix-orange">open_in_new</mat-icon>
                              </button>
                            </mat-form-field>
                          </div>
                        }
                        <!-- New release button -->
                        <div style="flex: 0 0 150px; max-width: 150px; cursor: pointer;" (click)="openReleaseNotes(null, true)">
                          <mat-form-field appearance="outline" [ngClass]="{'editable-outline': true}" [class.disabled]="true" style="width: 100%">
                            <mat-icon matPrefix class="icon-color-fix-orange">add</mat-icon>
                            <input matInput [value]="'New release'" readonly />
                          </mat-form-field>
                        </div>
                      </div>
                    }
                    <mat-dialog-actions align="end">
                      <button class="btn button-fix button-color-fix-red" mat-button (click)="onCancel()" cdkFocusInitial>Cancel</button>
                      <button class="btn button-fix button-color-fix-orange"
                        mat-button
                        [disabled]="!anyChange()"
                        (click)="onSave()"
                        [matTooltip]="anyChange() ? (editForm.value.isNewRow ? 'Create new release' : 'Save changes') : 'Please set values'">
                        {{editForm.value.isNewRow ? 'Create' : 'Save'}}
                        <mat-icon style="color:white !important" class="icon-color-fix">
                          {{
                          editForm.value.isNewRow ? 'add_box' :
                          'save'
                          }}
                        </mat-icon>
                      </button>
                    </mat-dialog-actions>
                  </form>